import { useTranslation } from "react-i18next";

import { IRoutePattern } from "../../../@types/Route";
import { MobileAvatar } from "../../../components/UserSettings";
import { useLeftPanel } from "../../../hooks/useLeftPanel";
import { mixpanelActions } from "../../../utils/mixpanel";
import { Link } from "../Link";
import {
  Container,
  BothDevicesSection,
  DisabledOverlay,
  Divider,
  IconContainer,
  List,
  ListItem,
  MobileSection,
} from "./LeftPanelMenu.styles";

interface ILeftPanelMenuItemProps extends IRoutePattern {
  onClick: () => void;
}
type ILeftPanelMenuProps = {
  items: IRoutePattern[];
  onLeftPanelMenuItemClick: () => void;
};

export function LeftPanelMenuItem({
  path,
  name,
  labelKey,
  Icon,
  context,
  onClick,
  disabled,
}: ILeftPanelMenuItemProps) {
  const { t } = useTranslation();

  const handleOnClickOverListItem = () => {
    if (disabled) return;

    mixpanelActions.track(`${context}: Sub-Nav ${name}`);
    onClick();
  };

  return (
    <ListItem
      onClick={handleOnClickOverListItem}
      disabled={disabled}
      key={`${Math.random()}-${path}`}
    >
      {disabled && <DisabledOverlay role="link" aria-disabled />}

      <Link to={path}>
        <IconContainer>
          <Icon width="22px" height="22px" />
        </IconContainer>

        <p>{labelKey ? t(labelKey) : name}</p>
      </Link>
    </ListItem>
  );
}

export function LeftPanelMenu({
  items,
  onLeftPanelMenuItemClick,
}: ILeftPanelMenuProps) {
  const { isMobileLeftPanelMenuOpen, setIsMobileUserSettingsMenuOpen } =
    useLeftPanel();

  const renderLeftBarItems = () => {
    return items
      .filter(({ hidden }) => !hidden)
      .map(({ name, labelKey, path, Icon, disabled, context }) => (
        <LeftPanelMenuItem
          name={name}
          labelKey={labelKey}
          key={`${Math.random()}-${path}`}
          path={path}
          context={context}
          onClick={onLeftPanelMenuItemClick}
          disabled={disabled}
          Icon={Icon}
        />
      ));
  };

  const handleMobileAvatarClick = () => {
    setIsMobileUserSettingsMenuOpen(true);
  };

  return (
    <Container mobileLeftPanelMenuOpen={isMobileLeftPanelMenuOpen}>
      <BothDevicesSection>
        <List>{renderLeftBarItems()}</List>
      </BothDevicesSection>

      <MobileSection>
        <Divider />
        <MobileAvatar onClick={handleMobileAvatarClick} />
      </MobileSection>
    </Container>
  );
}
